import React, { useEffect } from "react";
import { useForm } from 'react-hook-form';

// components
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  FormGroup,
  Input,
  Button,
  Spinner
} from "reactstrap";
import Select from 'react-select'

// style
import "../../../assets/css/loading.css";

// services
import { showMessage } from "../../../services/message.js";
import { api_GET, api_POST, api_PUT } from "../../../services/api_service.js";
import { getSessionCookie} from "../../../services/session.js";

export default function JustificativaForm({history, handleReturn, item}) {
    
    const session = getSessionCookie();

    const { register, handleSubmit, errors, setError, setValue, clearErrors } = useForm({ mode: "onBlur" });

    const [showLoading, setshowLoading] = React.useState(false);

    // Modalidade
    const [optionsModalidadesColeta, setoptionsModalidadesColeta] = React.useState([]);
    const [modalidadeColeta, setModalidadeColeta] = React.useState(null);
    const loadOptionsModalidadesColeta = () => {        
        api_GET(`modalidadeColeta`).then(result => {            
            if (result.status !== 200) {
              showMessage("Aviso", result.message, 'error', null);
            }
            else{
                setoptionsModalidadesColeta(result.data);
            }
          });
    }
    useEffect(() => {    
        if (item != null && item.modalidadeColetaId != null){
            setModalidadeColeta(optionsModalidadesColeta.filter(f => f.modalidadeColetaId == item.modalidadeColetaId)[0]);             
        }         
    }, [optionsModalidadesColeta]);        
    const handleModalidadesColeta = event => {
        let value = event;
        setModalidadeColeta(value);
        clearErrors("modalidadeColeta");            
    }

    const [options_status, set_options_status] = React.useState([]);
    const [status, setStatus] = React.useState("");    
    const loadOptionsStatus = () => {
        let list = [];
        if (session.perfil != "Gestor" && session.perfil != "Master")
        {
            if (item == null)
            {
                list.push({value: "Pendente de Liberação", label: "Pendente de Liberação"});
                setStatus("Pendente de Liberação");
            }
            else
                list.push({value: item.status, label: item.status});
        }
        else{
            list.push({value: "Pendente de Liberação", label: "Pendente de Liberação"});
            list.push({value: "Ativo", label: "Ativo"});
            list.push({value: "Inativo", label: "Inativo"});
        }

        set_options_status(list);
    }
    const handleStatus = (value) => {
        setStatus(value);
        clearErrors("status");
    }

    const [coletaParcial, setColetaParcial] = React.useState(false);

    const options_acao_coleta = [
        { label: 'Obrigatório Executar', value: '0' },
        { label: 'Não Pode Executar', value: '1' },
        { label: 'Pode Executar Opcionalmente', value: '2' }        
    ];
    const [acaoColeta, setAcaoColeta] = React.useState(null);    
    const handleAcaoColeta = (value) => {
        setAcaoColeta(value);
        clearErrors("acaoColeta");
    }

    const onSubmit = (data) => {    
                
        if (status == "")
        {
            setError("status");
            return;
        }

        if (modalidadeColeta == null){
            setError("modalidadeColeta");
            return;
        }
        
        if (data.coleta_parcial && acaoColeta == null)
        {
            setError("acaoColeta");
            return;
        }

        let json_submit = {
            justificativaId: item == null ? 0 : item.justificativaId,
            descricao: data.descricao,
            status: status,
            coletaParcial: data.coleta_parcial,
            naoColeta: data.nao_coleta,
            inconformidade: data.inconformidade,
            suspensaoOS: data.suspensao_os,
            pausaOS: data.pausa_os,
            registroOcorrencia: data.registro_ocorrencia,
            acaoJustificativaColeta: acaoColeta == "" ? null : acaoColeta,
            usuarioCadastroId: session.usuarioId,
            usuarioAtualizacaoId: session.usuarioId,
            modalidadeColetaId: modalidadeColeta.modalidadeColetaId,
            comprovanteDestinacaoNaoRegistrado: data.comprovante_destinacao
        }

        setshowLoading(true);
        if(json_submit.justificativaId == 0){
            api_POST('justificativa',json_submit).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error' , null);
                }
                else{
                    showMessage("Aviso", "Operação executada com sucesso!", 'success' , function(){
                        handleReturn(result.data);
                    });
                }
            });
        }
        else{
            api_PUT('justificativa',json_submit).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error' , null);
                }
                else{
                    showMessage("Aviso", "Operação executada com sucesso!", 'success' , function(){
                        handleReturn(result.data);
                    });
                }
            });
        }
    };

    const [disableAll, setdisableAll] = React.useState(false);
    useEffect(() => { 
        loadOptionsStatus();  
        loadOptionsModalidadesColeta();         
        setValue("descricao", item == null ? "" : item.descricao);        
        setValue("coleta_parcial", item == null ? "" : item.coletaParcial);
        setValue("nao_coleta", item == null ? "" : item.naoColeta);
        setValue("inconformidade", item == null ? "" : item.inconformidade);
        setValue("suspensao_os", item == null ? "" : item.suspensaoOS);
        setValue("pausa_os", item == null ? "" : item.pausaOS);
        setValue("registro_ocorrencia", item == null ? "" : item.registroOcorrencia);     
        setValue("comprovante_destinacao", item == null ? "" : item.comprovanteDestinacaoNaoRegistrado);

        if (item != null){
            setStatus(item.status);            
            setAcaoColeta(item.acaoJustificativaColeta);
            setColetaParcial(item.coletaParcial);

            if (session.perfil != "Gestor" && session.perfil != "Master" && item.status != "Pendente de Liberação")
                setdisableAll(true);
        }
    }, [item]);

    return (
    <>                
        {showLoading && 
          <div className="carregandoCmp">
              <div className="box">
                <label style={{marginRight:"20px"}}>Carregando...</label>
                <Spinner size="sm" color="info" />
              </div>
          </div> 
        }      
        <Row>
            <Container fluid>
                <Card className="shadow">

                    <CardHeader className="border-0">
                        <strong> Cadastro de Justificativa</strong>
                    </CardHeader>
                    <CardBody>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Row>
                                    <Col md="3" lg="4">
                                        <FormGroup>
                                            <label className="form-control-label">
                                            Status
                                            </label>
                                            <Select
                                                options={options_status}
                                                name="status"
                                                onChange={(e) => {handleStatus(e.value)}}
                                                value={options_status.find(obj => obj.value === status)}
                                                placeholder="Selecione"
                                                isDisabled={disableAll ? "yes" : ""}
                                            />
                                            {errors.status && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col> 
                                    <Col md="9" lg="8">
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="input-address" >
                                            Modalidade de Serviço
                                            </label>
                                            <Select
                                                name="modalidadeColeta"
                                                options={optionsModalidadesColeta}
                                                getOptionLabel={({descricao}) => descricao}
                                                getOptionValue={({modalidadeColetaId}) => modalidadeColetaId} 
                                                onChange={(value) => {handleModalidadesColeta(value)}}
                                                value={modalidadeColeta != null && optionsModalidadesColeta.find(obj => obj.modalidadeColetaId === modalidadeColeta.modalidadeColetaId)}
                                                placeholder="Selecione"                                                
                                            />
                                            {errors.modalidadeColeta && <span className="form-control-label text-danger">* Campo Obrigatório</span>}                                    
                                        </FormGroup>
                                    </Col>
                                    <Col md="12" lg="12">
                                        <FormGroup>
                                            <label className="form-control-label">
                                            Descrição
                                            </label>
                                            <Input                                            
                                                name="descricao"
                                                placeholder="Descrição"
                                                type="text"
                                                innerRef={register({ required: true})}                                        
                                                disabled={disableAll ? "disabled" : ""}
                                            />
                                            {errors.descricao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>                                                                
                                </Row>
                                <Row><Col md="12"><label className="form-control-label">Tipo</label></Col></Row>
                                <Row>
                                    <Col md="6" lg="4">
                                        <FormGroup check>
                                            <label check className="form-control-label">
                                                <Input                                                    
                                                    name="coleta_parcial"                                            
                                                    type="checkbox"                                            
                                                    onChange={(value) => setColetaParcial(value)}
                                                    innerRef={register()}
                                                    disabled={disableAll ? "disabled" : ""}
                                                />
                                                Execução Parcial
                                            </label>                                        
                                        </FormGroup>
                                    </Col> 
                                    <Col md="6" lg="4">
                                        <FormGroup check>
                                            <label check className="form-control-label">
                                                <Input                                                    
                                                    name="nao_coleta"                                            
                                                    type="checkbox"                                            
                                                    innerRef={register()}                                
                                                    disabled={disableAll ? "disabled" : ""}
                                                />
                                                Não Execução
                                            </label>                                        
                                        </FormGroup>
                                    </Col> 
                                    <Col md="6" lg="4">
                                        <FormGroup check>
                                            <label check className="form-control-label">
                                                <Input                                                    
                                                    name="inconformidade"                                            
                                                    type="checkbox"                                            
                                                    innerRef={register()}
                                                    disabled={disableAll ? "disabled" : ""}
                                                />
                                                Inconformidade
                                            </label>                                        
                                        </FormGroup>
                                    </Col> 
                                    <Col md="6" lg="4">
                                        <FormGroup check>
                                            <label check className="form-control-label">
                                                <Input                                                    
                                                    name="suspensao_os"                                            
                                                    type="checkbox"                                            
                                                    innerRef={register()}
                                                    disabled={disableAll ? "disabled" : ""}
                                                />
                                                Suspensão de OS
                                            </label>                                        
                                        </FormGroup>
                                    </Col> 
                                    <Col md="6" lg="4">
                                        <FormGroup check>
                                            <label check className="form-control-label">
                                                <Input                                                    
                                                    name="pausa_os"                                            
                                                    type="checkbox"                                            
                                                    innerRef={register()}
                                                    disabled={disableAll ? "disabled" : ""}
                                                />
                                                Pausa de OS
                                            </label>                                        
                                        </FormGroup>
                                    </Col> 
                                    <Col md="6" lg="4">
                                        <FormGroup check>
                                            <label check className="form-control-label">
                                                <Input                                                    
                                                    name="registro_ocorrencia"                                            
                                                    type="checkbox"                                            
                                                    innerRef={register()}
                                                    disabled={disableAll ? "disabled" : ""}
                                                />
                                                Registro de Ocorrência
                                            </label>                                        
                                        </FormGroup>
                                    </Col> 
                                    <Col md="6" lg="4">
                                        <FormGroup check>
                                            <label check className="form-control-label">
                                                <Input                                                    
                                                    name="comprovante_destinacao"                                            
                                                    type="checkbox"                                            
                                                    innerRef={register()}
                                                    disabled={disableAll ? "disabled" : ""}
                                                />
                                                Não registro de Comprovante de Descarregamento
                                            </label>                                        
                                        </FormGroup>
                                    </Col> 
                                </Row>                                
                                {coletaParcial &&
                                    <Row className="mt-4">
                                        <Col md="12" lg="6">
                                            <FormGroup>
                                                <label className="form-control-label" htmlFor="input-address" >
                                                Permissão para concluir Execução Parcial
                                                </label>
                                                <Select
                                                    options={options_acao_coleta}
                                                    name="acaoColeta"
                                                    onChange={(e) => {handleAcaoColeta(e.value)}}
                                                    value={options_acao_coleta.find(obj => obj.value == acaoColeta)}
                                                    placeholder="Selecione"
                                                    isDisabled={disableAll ? "yes" : ""}
                                                />
                                                {errors.acaoColeta && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>                                                               
                                    </Row>
                                }
                                <Row>
                                <Col md="12" className="text-center">                                
                                    <FormGroup>
                                        <Button color="warning" type="button" onClick={() => {handleReturn()}}>Voltar</Button>
                                        {!disableAll && <Button color="success">Salvar</Button>}
                                    </FormGroup>
                                </Col>
                            </Row>

                        </form>
                    </CardBody>
                </Card>
            </Container>
        </Row>        
    </>
    );
}
